import { SalesRecording, TripMatch, TripRequest } from '@marageti/z4-sdk/lib/travel';
import React from 'react';
import TripMatchDetailsView from './trip-match-details-view';
import useReviewPromptTripMatch from '../../hooks/use-show-review-prompt';

const TripMatchDetails = ({
  isLoading,
  salesRecordings,
  tripMatch,
  tripRequest,
}: {
  isLoading: boolean,
  salesRecordings: SalesRecording[] | undefined,
  tripMatch: TripMatch,
  tripRequest: TripRequest,
}) => {
  const { reviews, reviewPrompt } = useReviewPromptTripMatch(tripMatch, tripRequest.visibilityFlags.hideReviewRequest);

  return (
    <TripMatchDetailsView
      isLoading={isLoading}
      tripMatch={tripMatch}
      reviews={reviews}
      reviewPrompt={reviewPrompt}
      salesRecordings={salesRecordings}
      hideDetails={tripRequest.visibilityFlags.hideDetails}
    />
  );
};

export default TripMatchDetails;
